module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71999/img/content-remix-post-publish/content-remix-de.png"